// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Receita_BreakdownInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /dashboards/receita/breakdown
 *
 * Validates the dim query parameter for breakdown dimension.
 */
import { registerContract } from './validate'

export interface Receita_BreakdownInput {
dim?: string
}

registerContract('Receita_BreakdownInput', {
  dim: { type: 'string',  required: false },
})
